<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2eQbjb/tc-custom/9781466868748.jpg?1730984877274" alt="This image is the cover for the book Death Wave, The Grand Tour"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Death Wave, The Grand Tour
      </h1>
      <p class="bookDescription body article font2">
        <p>Six-time Hugo Award winner Ben Bova chronicles the saga of humankind's expansion beyond the solar system in <i>Death Wave</i><br/><br/>In the precursor to the Star Quest Trilogy, <i>New Earth</i>, Jordan Kell led the first human mission beyond the solar system. They discovered the ruins of an ancient alien civilization. But one alien AI survived, and it revealed to Jordan Kell that an explosion in the black hole at the heart of the Milky Way galaxy has created a wave of deadly radiation, expanding out from the core toward Earth. Unless the human race acts to save itself, all life on Earth will be wiped out. <br/><br/>When Kell and his team return to Earth, many years after their departure, they find that their world has changed almost beyond recognition. Not only has a second wave of greenhouse flooding caused sea levels to rise, but society has been changed by the consequences of the climate shift. Few people want to face Jordan Kell's news. He must convince Earth's new rulers that the human race is in danger of extinction unless it acts to forestall the death wave coming from the galaxy's heart.<br/><br/>The Star Quest Trilogy<br/>#1 Death Wave<br/>#2 Apes and Angels<br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ben Bova
      </h2>
      
      <p class="authorDescription body article"><P><B>Ben Bova</B> (1932-2020) was the author of more than a hundred works of science fact and fiction, including <I>Able One, Transhuman, Orion</I>, the Star Quest Trilogy, and the Grand Tour novels, including <I>Titan</I>, winner of John W. Campbell Memorial Award for best novel of the year. His many honors include the Isaac Asimov Memorial Award in 1996, the Lifetime Achievement Award of the Arthur C. Clarke Foundation in 2005, and the Robert A. Heinlein Award “for his outstanding body of work in the field of literature” in 2008.<br><br>Dr. Bova was President Emeritus of the National Space Society and a past president of Science Fiction Writers of America, and a former editor of <I>Analog</I> and former fiction editor of <I>Omni</I>. As an editor, he won science fiction’s Hugo Award six times. His writings predicted the Space Race of the 1960s, virtual reality, human cloning, the Strategic Defense Initiative (Star Wars), electronic book publishing, and much more.<br><br>In addition to his literary achievements, Bova worked for Project Vanguard, America’s first artificial satellite program, and for Avco Everett Research Laboratory, the company that created the heat shields for Apollo 11, helping the NASA astronauts land on the moon. He also taught science fiction at Harvard University and at New York City’s Hayden Planetarium and worked with such filmmakers as George Lucas and Gene Roddenberry.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2fce9b54